import {BackendLanguageTag} from '../../backend/enums/backend-language-tag';
import {translations} from '../../i18n/translations';

/**
 * Array with the available languages in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(languages[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const languages: Array<{translation: string; type: BackendLanguageTag}> = [
  {
    translation: translations.languages[BackendLanguageTag.ptPT],
    type: BackendLanguageTag.ptPT,
  },
  {translation: translations.languages[BackendLanguageTag.esES], type: BackendLanguageTag.esES},
  {translation: translations.languages[BackendLanguageTag.glES], type: BackendLanguageTag.glES},
  {translation: translations.languages[BackendLanguageTag.enUS], type: BackendLanguageTag.enUS},
  {translation: translations.languages[BackendLanguageTag.ptBR], type: BackendLanguageTag.ptBR},
];
